import { track } from '@eventbrite/datalayer-library';
import { Modal, ModalType } from '@eventbrite/eds-modal';
import loadable from '@loadable/component';
import React, { useEffect } from 'react';

const trackbotEvents = (event: any) => {
    track({
        eventName: 'chatbot-events',
        eventData: {
            eventName: event.eventName,
            question: event.question || null,
        },
    });
};

interface AISearchModalProps {
    currentLocation: string;
    isBotRequest?: boolean;
    /**
     * Whether the chatbot modal is open by default
     */
    isOpen?: boolean;
    /**
     * Callback to be called when the chatbot modal is closed
     */
    onClose?: () => void;
}

export const AISearchModal = ({
    isBotRequest,
    isOpen = false,
    currentLocation,
    onClose,
}: AISearchModalProps) => {
    useEffect(() => {
        // trackbotEvents({ eventName: 'CHATBOT_BANNER_LOADED' });
        if (isOpen) {
            trackbotEvents({ eventName: 'OPEN_CHATBOT' });
        }
    }, [isOpen]);

    const closeModal = () => {
        trackbotEvents({ eventName: 'CLOSE_CHATBOT' });
        onClose?.();
    };

    if (isBotRequest || !isOpen) {
        return null;
    }

    const LazyConciergeScreen = loadable(
        () => import('@eventbrite/smalltalk-ui'),
        {
            resolveComponent: (components: {
                ConciergeScreen: React.FunctionComponent<any>;
            }) => components.ConciergeScreen,
            ssr: false,
        },
    );

    return (
        <Modal
            isShown={isOpen}
            type={ModalType.complex}
            onClose={closeModal}
            isPortal={true}
            noPadding={true}
            isClosable={false}
        >
            <LazyConciergeScreen location={currentLocation} />
        </Modal>
    );
};
